import React, { useEffect, useRef, useState } from "react";
import "./BybCustomer.css";
// import find from "/src/assets/images/find.svg"
// import bannerpic from "../../assets/images/header_banner.png"
// import optimize from "/src/assets/images/optimize.svg"
// import box1 from "../../assets/images/box1.svg"
// import box2 from "../../assets/images/box2.svg"
// import box3 from "../../assets/images/box3.svg"
// import {Link} from "react-router-dom";

const BrandSelf = () => {
  const triggerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);



  const textRef = useRef(null);

    // Intersection Observer for fade-in text
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting); // Set visibility based on intersection
        },
        {
          threshold: 0.5, // Trigger when 50% of the element is visible
        }
      );
  
      const textElement = textRef.current;
      if (textElement) observer.observe(textElement);
  
      return () => {
        if (textElement) observer.unobserve(textElement);
      };
    }, []);
    
    useEffect(() => {
      // Ensure Typeform embed script is loaded
      const script = document.createElement('script');
      script.src = '//embed.typeform.com/next/embed.js';
      script.async = true;
      document.body.appendChild(script);
  
      return () => {
        document.body.removeChild(script);
      };
    }, []);

  return (
    <section className="new_byb check_list byb_believe ">
      <div className="container">
      

      <p className="text-center para_p p_txt">Assess where you are, identify the gaps, and uncover new opportunities for growth.  
                          </p>

                         <a href="https://rzp.io/rzp/brewyourbrand-checkout" className="blue_btn join_btn  mx-auto">Buy Now</a>

                         <div className="box_img text-center">
                          <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/header_banner.png" alt="Brand self-audit kit banner preview" className="center_img" />
                         </div>


      </div>

      <div className="container" id="tools">
        <div className="row">
          <div className="col-lg-12">
          <div className="card_wrapper d-block d-lg-flex d-md-flex" >
                  <div className="card_box">
                       <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/box1.svg" alt="Strategy blueprints tool visual" srcset="" />
                       <p className="card_desc"><span className="text-white">Strategy Blueprints</span> Utilize customizable frameworks to guide purposeful and profitable brand-building. 
                       </p>
                  </div>

                  <div className="card_box">
                       <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/box2.svg" alt="Skillup decks tool visual" srcset="" />
                       <p className="card_desc"><span className="text-white">Skillup Decks 
                       </span> Pick up skills and spark new directions  
                       in campaigns, content and business. 
                       </p>
                  </div>


                  <div className="card_box">
                       <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/box3.svg" alt="Performance trackers tool visual" srcset="" />
                       <p className="card_desc"><span className="text-white">Performance Trackers </span> Monitor progress and fine-tune your strategy  
                       based on real-time feedback.  
                       </p>
                  </div>
          </div>  
          </div>
    
        </div>
      </div>
    </section>
  );
};

export default BrandSelf;
